export default __webpack_public_path__ + "static/media/SG-Green-0007.f932dbcc.png";